module.exports = __webpack_public_path__ + "static/media/wizualizacja-132.e77283ba.png";